import autoMarkItemAsRead from '../../helpers/autoMarkItemAsRead';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action, select } from 'satcheljs/lib/legacy';

export interface OnItemPartDeselectedState {
    userOptions: UserOptionsType;
}

/**
 * Called when the table has single selection, and user selects another single conversation
 * @param itemId the id of itemId which is going to be deselected
 * @param tableView the tableView where the single selection changed
 * @param state the state which contains userOptions
 */
export default action('onItemPartDeselected')(
    select({
        userOptions: () => getUserConfiguration().UserOptions,
    })(function onItemPartDeselected(
        itemId: string,
        tableView: TableView,
        state?: OnItemPartDeselectedState
    ) {
        if (!tableView) {
            // tableView can be null when browsing photos from Photohub with inline-compose open
            return;
        }

        if (state.userOptions.PreviewMarkAsRead == 'OnSelectionChange') {
            autoMarkItemAsRead(itemId, tableView);
        }
    })
);
